import { Box, Stack, styled } from '@mui/material';

type ScrollableContentHeaderProps = {
  hasOverflow: boolean;
};

export const ScrollableContentRoot = styled(Stack)({
  height: '100%',
  minHeight: 0,
});

export const ScrollableContentHeader = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'hasOverflow',
})<ScrollableContentHeaderProps>(({ theme, hasOverflow }) => ({
  flexShrink: 0,
  gap: theme.spacing(0.5),
  padding: theme.spacing(1),
  boxShadow: hasOverflow ? theme.shadows[3] : theme.shadows[0],
  zIndex: 1,
}));

export const ScrollableContentBody = styled(Box)({
  flex: 1,
  minHeight: 0,
  overflowY: 'auto',
});
